<template>
  <div class="ListSettingOverlayContent">
    <h3 v-html="popoverTitle"></h3>
    <slot name="BinSelectionInput"></slot>
    <Listbox :modelValue="selectedOption" :options="options" @update:modelValue="onOptionSelected">
      <template #option="{option}">
        <div class="flex">
          <div class="iconBox">
            <i v-if="option == selectedOption" class="pi pi-check" style="font-size: 22px;"></i>
          </div>
          <div>
            {{ option.caption }}
          </div>
        </div>
      </template>
    </Listbox>
    <Button v-if="showingDisableSetting" severity="secondary" @click="$emit('disableSetting')">
      <i class="pi pi-wrench" style="font-size: small; margin-right: 10px;"></i>
      Disable setting
    </Button>
    <div v-if="helpText" class="helpText" v-html="helpText"></div>
  </div>
</template>

<script setup>
import { changeSettings } from "./appUtility.js";

let props = defineProps([
  "selectedCells",
  "showingPopover",
  "popoverTitle",
  "options",
  "selectedOption",
  "onOptionSelected",
  "showingDisableSetting",
  "helpText"
]);

let showingPopover = defineModel("showingPopover");

defineEmits(["selectOption", "disableSetting"]);

function onOptionSelected(option) 
{
  // The 'option' argument will be null after selecting the already selected option.
  let value = option?.value ?? props.selectedOption.value;

  if (props.onOptionSelected) {
    props.onOptionSelected(value);
    return;
  }
  else {
    showingPopover.value = false;
    changeSettings(props.selectedCells, cell => [{
      handle: cell.componentArgs.tag.handle,
      value
    }]);
  }
}
</script>

<style>
.ListSettingOverlayContent {
  max-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
}
.ListSettingOverlayContent .p-listbox {
  width: 300px;
  font-size: large;
}
.ListSettingOverlayContent .p-listbox-item {
  padding: 15px;
}
.ListSettingOverlayContent .p-listbox-item.p-highlight {
  color: white;
  border-radius: 0;
  background-color: var(--blue-500);
}
.ListSettingOverlayContent .flex {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ListSettingOverlayContent .iconBox {
  width: 25px;
  display: flex;
  justify-content: center;
}
</style>